var path = '/components/player-preview/player-preview.component.html';
var html = "<div id=\"stageWrapper\">\n    <div id=\"stage\"></div>\n    <div class=\"previewNotification\">Preview of {{scene.name}}</div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;